import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ShoppingCart } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import PageMeta from "@/components/PageMeta";

export default function ShoppingJoin() {
  const { token } = useParams();
  const { user } = useAuth();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const next = encodeURIComponent(`/shopping/join/${token}`);

  useEffect(() => {
    api.get(`/shopping-list/invite/${token}`)
      .then((r) => setInfo(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "This invite isn't valid."));
  }, [token]);

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/shopping-list/invite/${token}/accept`);
      localStorage.setItem("rf_shop_list_id", data.list_id);
      toast.success(`You're now sharing ${data.owner_name}'s shopping list`);
      nav("/shopping");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Couldn't join");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-xl mx-auto px-6 py-16" data-testid="shopping-join-page">
      <PageMeta title="Join a shared shopping list" noindex />
      <div className="bg-white rounded-3xl border border-rf-ink/10 p-8 sm:p-10">
        <ShoppingCart size={36} weight="duotone" className="text-rf-orange mb-4" />
        {err ? (
          <p className="text-rf-ink" data-testid="shopping-join-error">{err}</p>
        ) : !info ? (
          <p className="text-rf-ink-soft">Loading invite…</p>
        ) : (
          <>
            <h1 className="font-display text-3xl font-black text-rf-ink mb-3" data-testid="shopping-join-title">
              {info.owner_name} shared a shopping list with you
            </h1>
            <p className="text-rf-ink-soft mb-6">Add items, tick them off in the shop and see each other&apos;s changes live.</p>
            {user ? (
              <button onClick={accept} disabled={busy} data-testid="shopping-join-accept" className="btn-orange disabled:opacity-50">
                {busy ? "Joining…" : "Join the shopping list"}
              </button>
            ) : (
              <div className="flex flex-wrap gap-3">
                <Link to={`/register?next=${next}`} data-testid="shopping-join-register" className="btn-orange">Create a free account</Link>
                <Link to={`/login?next=${next}`} data-testid="shopping-join-login" className="btn-outline-ink">I already have an account</Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
